import React, { useEffect, useState } from "react";
/* eslint-disable */
import { Container, Row, Col } from "reactstrap";

const ECSFlavours = ({ ecsflavours }) => {
    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            setMobile({ mobile: true });
        }
    }, []);
    return (
        <div className="ecs-flavours-bg ">
            <Container>
                <p className={"header-detased-flavor text-left"}>ECS Flavors</p>
                {ecsflavours.map((res) => (
                    <div key={res} className="overview-paragraph">
                        <p className={!mobile ? "border-p-left-flavor text-left" : "border-p-left-flavor"}>{res}</p>
                    </div>
                ))}

                {/* <div className="region-wrapper ml-0 pl-0">
                    <h5 className="region-header text-left">Select region</h5>
                </div>
                <Row>
                    <Col md="3">
                        <div className="riyadh-img image-bg">Riyadh, Saudia Arabia</div>
                    </Col>
                    <Col md="3">
                        <div className="jeddah-img image-bg">Jeddah, Saudi Arabia</div>
                    </Col>
                    <Col md="3">
                        <div className="karachi-img image-bg">Karachi, Pakistan</div>
                    </Col>
                    <Col md="3">
                        <div className="lahore-img image-bg">Lahore, Pakistan </div>
                    </Col>
                </Row> */}
            </Container>
        </div>
    );
}

export default ECSFlavours;
